package com.neurobs.ccabserver.transcriptreviewadmin.states

import com.neurobs.ccab.casr.TranscriptMetrics
import com.neurobs.ccab.db.StudyData
import com.neurobs.js.ccab.{CASRServer, CCABServer}
import com.neurobs.js.util.ServerResponseUtil
import com.neurobs.react.{GenericState, GenericStateGenerator, ServerDataAttribute, StateAttribute}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks._
import slinky.core.facade.ReactElement

case class TranscriptMetricsState (
  studiesState: ServerDataAttribute[List[StudyData]],
  studyTranscriptMetricsState: StateAttribute[Map[Long, Either[String, TranscriptMetrics]]]
                                  ) extends GenericState {

  def addStudyTranscriptMetrics(studyId: Long, transcriptMetrics: Either[String, TranscriptMetrics]) = {
    val newMap = studyTranscriptMetricsState.value.updated(studyId, transcriptMetrics)
    studyTranscriptMetricsState.setValue(newMap)
  }

  def loadServerStudies() = {
    CCABServer.getAllStudies(handleServerStudies)
  }

  def handleServerStudies = ServerResponseUtil.handleObjectResultResponse[Seq[StudyData]](
    handleObject = studies => {
      studiesState.setData(studies.toList)
    },
    onAnyError = studiesState.setError(_)
  )


}

object TranscriptMetricsStateGenerator extends GenericStateGenerator[TranscriptMetricsState] {
  override def generateEmptyDefaultState(): TranscriptMetricsState = TranscriptMetricsState(
    emptyServerDataState[List[StudyData]](),
    emptyDefaultState(Map[Long, Either[String, TranscriptMetrics]]())
  )
}

@react
object TranscriptMetricsStateProvider {
  case class Props(children: ReactElement*)
  val component = FunctionalComponent[Props] { props =>

    val studiesState = ServerDataAttribute(useState[Either[Option[String], List[StudyData]]](Left(None)))
    val studyTranscriptMetricsState = StateAttribute(useState(Map[Long, Either[String, TranscriptMetrics]]()))

    val transcriptMetricsState = TranscriptMetricsState(
      studiesState = studiesState,
      studyTranscriptMetricsState = studyTranscriptMetricsState
    )

    useEffect(() => {
      transcriptMetricsState.loadServerStudies()
    }, Vector())


    TranscriptMetricsStateGenerator.Provider(transcriptMetricsState)(
      props.children:_*
    )

  }
}


